import { Button, Paper, Stack, Typography } from '@mui/material';
import { signOut } from 'aws-auth-lib';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useRole } from '../utils/RoleContext';
import { useUser } from '../hooks/useUser';
import { resetUser } from '../store/userReducer';

const Restricted = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setRole } = useRole();
    const { user } = useUser();

    const handleLogout = async () => {
        try {
            await signOut();
        } catch {
            // best effort
        }

        dispatch(resetUser());
        setRole(null);
        sessionStorage.removeItem('role');
        if (user?.uuid) {
            localStorage.removeItem(`${user.uuid}-role`);
        }
        navigate('/login', { replace: true });
    };

    return (
        <Paper sx={{ p: 4, width: 520 }}>
            <Stack spacing={2}>
                <Typography variant="h5" fontWeight={700}>
                    Acesso Restrito
                </Typography>
                <Typography>
                    Plataforma restrita a equipa clinica e de gestao do Info.cuidador 2.0.
                </Typography>
                <Button variant="contained" onClick={handleLogout} sx={{ alignSelf: 'flex-start' }}>
                    Logout
                </Button>
            </Stack>
        </Paper>
    );
};

export default Restricted;

